import React, { useEffect } from 'react';
import Canvas from './Canvas.js';
import { motion } from "framer-motion";


const Thumbnail = props => {
    return (
        <motion.div 
          className="column is-one-third-tablet ">
            <div className="is-relative has-text-white" >
                <Canvas element={props.token.vid} token={props.token} display="canvas" setFullscreenCanvas={props.setFullscreenCanvas} />
            </div>
        <div className="columns is-mobile ">
          <div className="column is-half">
            <p className="sp-label">Owner</p>
            <p className="is-size-7"><a href={props.token.ownerUrl} target="_blank" className="has-text-black">{props.token.ownerShort}</a></p>
          </div>
          {props.token.salePrice && (
          <div className="column is-half has-text-right is-hidden-mobile">
            <p className="sp-label">On auction</p>
            <p className="is-size-7"><a target="_blank" className="has-text-black" href={props.token.salePriceUrl}>{props.token.salePrice} ETH</a></p>
          </div>  
          )}
        </div>
      </motion.div>
    )
};

const Footer = props => {
  // <button className="button is-size-7 is-primary is-rounded is-outlined" onClick={props.loadMoreTokens}>Load more</button>
  // https://rinkeby.artblocks.io/project/
  return (
    <footer className="section has-text-centered">
              
          <a className="button is-size-7 is-primary is-rounded is-outlined" href={"https://artblocks.io/project/" + props.blockchain.artblock.projectId}  target="_blank" rel="noreferrer">See more on Artblocks.io</a>
    </footer>
  )
};

const Gallery = props => {
  const isNegative = false;
  useEffect(()=> {
    props.setCanvas({enabled:false, display:"foreground", token:props.tokenList[0]});
  },[props.tokenList]);

  const shortenAddress = address => {
    return (address.substr(0,6) + "..." + address.substr(address.length-4, 4))
  }

  const loadNewToken = async(id) => {
    let newToken = {};
    newToken.id = id - props.blockchain.artblock.tokenPrefix;
    newToken.hash = await props.blockchain.infura.contract.methods.tokenIdToHash(id).call();
    newToken.owner = await props.blockchain.infura.contract.methods.ownerOf(id).call();
    newToken.ownerShort = shortenAddress(newToken.owner);
    newToken.ownerUrl = props.blockchain.etherscan.address + newToken.owner;
    newToken.vid = id;
    newToken.salePrice = null;
    props.tokenList.push(newToken);
  }

  const loadMoreTokens = () => {
    // Find out how many you need to load
    let n = props.blockchain.artblock.projectTokenInfo.invocations - props.tokenList.length;
    if (n > 0) {
      // There is something to load
      console.log("Still " + n + " videos to load.");
      for (let i = 1; i <= n; i++) {
        let loadId = props.tokenList[props.tokenList.length-1].id + props.blockchain.artblock.tokenPrefix - i;
        loadNewToken(loadId);
      }
    }
    props.setModal({enabled:true, message:"Functionality not implemented yet!"});
  }
  return (
    <>
    <motion.section 
       initial={{y:50, opacity:0}}
       animate={{y:0, opacity:1}}
       transition={{delay:0.1, duration:0.5}}
       className="section main has-text-black"
      >
      <div className="columns is-multiline">
        {props.tokenList.map((token, index) => (
          <Thumbnail
            setFullscreenCanvas={props.setCanvas} 
            token={token}
            key={index}
          />
        ))}
      </div>
      <Footer loadMoreTokens={loadMoreTokens} blockchain={props.blockchain} />

    </motion.section>
  </>
  )
  };
export default Gallery;